import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const subTasksImporterSelectors = importerSelectors(
  'subTasks.importer',
)

export default subTasksImporterSelectors
